import { InputFromUser } from '../../../components/Input/input';
import { CheckboxGroup } from '../../../components/Input/CheckboxGroup';
import { PainRatingScale } from '../../../components/Input/PainRatingScale';

export const AssessmentField = ({ field, values, handleChange, handleBlur, errors, touched, setFieldValue, isEditMode }) => {
    const { fieldKey, label, componentType, placeholder, options, gridClass, rows, conditionalLogic } = field;

    // Handle conditional rendering
    if (conditionalLogic) {
        const { showIf, condition } = conditionalLogic;
        const shouldShow = condition(values[showIf]);
        if (!shouldShow) return null;
    }

    const isDisabled = !isEditMode || fieldKey === 'age';
    const fieldPlaceholder = fieldKey === 'age' ? 'Auto-calculated from DOB' : placeholder;

    const commonProps = {
        label,
        name: fieldKey,
        value: values[fieldKey],
        error: errors[fieldKey],
        touched: touched[fieldKey],
        onBlur: handleBlur,
        FormGroupClassName: gridClass,
        LabelClassName: 'col-form-label',
        FormControlClassName: 'form-control',
        disabled: isDisabled,
    };

    switch (componentType) {
        case 'text':
        case 'number':
        case 'email':
            return (
                <InputFromUser
                    {...commonProps}
                    type={componentType}
                    placeholder={fieldPlaceholder}
                    onChange={handleChange}
                    disabled={isDisabled}
                />
            );

        case 'date':
            return (
                <InputFromUser
                    {...commonProps}
                    type="date"
                    placeholder={fieldPlaceholder}
                    onChange={(dateString) => {
                        setFieldValue(fieldKey, dateString);
                    }}
                    disabled={isDisabled}
                />
            );

        case 'radio':
            return (
                <InputFromUser
                    {...commonProps}
                    type="radio"
                    options={options}
                    selectedValue={values[fieldKey]}
                    onChange={(value) => {
                        handleChange({
                            target: { name: fieldKey, value },
                        });
                    }}
                    disabled={isDisabled}
                />
            );

        case 'singleSelect':
        case 'multiple':
            return (
                <InputFromUser
                    {...commonProps}
                    type={componentType}
                    options={options}
                    placeholder={fieldPlaceholder}
                    onChange={(value) => {
                        handleChange({
                            target: { name: fieldKey, value },
                        });
                    }}
                    disabled={isDisabled}
                />
            );

        case 'checkbox':
            return (
                <CheckboxGroup
                    {...commonProps}
                    options={options}
                    onChange={(value) => {
                        handleChange({
                            target: { name: fieldKey, value },
                        });
                    }}
                    disabled={isDisabled}
                />
            );

        case 'textarea':
            return (
                <div className={gridClass}>
                    <div className="form-group">
                        <label className="col-form-label" style={{ color: errors[fieldKey] && touched[fieldKey] && 'red' }}>
                            {label}
                            {errors[fieldKey] && <span className="login-danger"> *</span>}
                        </label>
                        <textarea
                            rows={rows || 10}
                            className="form-control"
                            placeholder={fieldPlaceholder}
                            name={fieldKey}
                            value={values[fieldKey]}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            disabled={isDisabled}
                            style={{
                                borderColor: errors[fieldKey] && touched[fieldKey] ? 'red' : '',
                                borderWidth: 1,
                                backgroundColor: isDisabled ? '#f5f5f5' : 'white',
                                cursor: isDisabled ? 'not-allowed' : 'text'
                            }}
                        />
                        {errors[fieldKey] && touched[fieldKey] && (
                            <div className="text-danger m-1">{errors[fieldKey]}</div>
                        )}
                    </div>
                </div>
            );

        case 'painRating':
            return (
                <PainRatingScale
                    {...commonProps}
                    onChange={(value) => {
                        handleChange({
                            target: { name: fieldKey, value },
                        });
                    }}
                    disabled={isDisabled}
                />
            );

        default:
            return null;
    }
};
